<i18n locale="en">
{
  "actions": {
    "close": "Close"
  },
  "logo-alt": "Owner Logo"
}
</i18n>
<template>
  <div class="full-page-editor-heading">
    <div class="full-page-editor-heading__lhs">
      <img src="/branding/owner-logo.svg" :alt="$t('logo-alt')" />
    </div>

    <slot v-if="$slots.topbar" name="topbar"></slot>

    <div class="full-page-editor-heading__rhs">
      <button
        class="full-page-editor-heading__close-button"
        @click="$emit('close')"
      >
        <span
          class="text-subtitle-2 slate-400"
          v-text="$t('actions.close')"
        ></span>
        <OwnIcon icon="x" size="sm" />
      </button>
    </div>
  </div>
</template>
<script>
import { OwnIcon } from '../OwnIcon'

export default {
  name: 'FullPageEditorHeading',
  components: {
    OwnIcon,
  },
}
</script>
<style lang="scss">
.full-page-editor-heading {
  width: calc(100% - 48px);
  margin-left: 24px;
  height: 64px;
  border-bottom: 1px solid $bluetiful-100;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &__lhs {
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    & > img {
      width: 104px;
    }
  }

  &__rhs {
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  &__close-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    & > span {
      margin-right: 4px;
    }
  }
}
</style>
